(function () {
    'use strict';

    angular
        .module('app.plan')
        .controller('PlanController', Plan);


    Plan.$inject = ['$cookies', '$scope', '$filter', 'DomainsService', 'CountriesService'];

    function Plan($cookies, $scope, $filter, DomainsService, CountriesService) {
        var vm = this;

        vm.budget = 0;
        vm.showEmptyTargetGroupWarning = true;

        vm.predicate = 'pseudoAffinity';
        vm.orderDesc = true;

        vm.targetGroup = {
            country: undefined,
            criteria: {},
            addCriterion: function (criterion) {
                switch (criterion) {
                case 'gender':
                case 'children':
                    vm.targetGroup.criteria[criterion] = [1, 2];
                    break;
                case 'age':
                    vm.targetGroup.criteria[criterion] = [16, 75];
                    break;
                case 'income':
                case 'education':
                    vm.targetGroup.criteria[criterion] = [1, 2, 3, 4, 5];
                    break;
                case 'employment':
                    vm.targetGroup.criteria[criterion] = [1, 2, 3, 4, 5, 6];
                    break;
                case 'householdsize':
                    vm.targetGroup.criteria[criterion] = [1, 2, 3, 4, 5];
                    break;
                }
            },
            removeCriterion: function (criterion) {
                delete vm.targetGroup.criteria[criterion];
            }
        };

        vm.topDomains = {
            data: [],
            loaded: false
        };

        vm.selectedDomains = [];

        activate();

        function activate() {

        }

        vm.isAllChecked = function () {
            return _.every(vm.topDomains.data, function (p) {
                return p.checked;
            });
        };

        vm.isAnyChecked = function () {
            return _.some(vm.topDomains.data, function (p) {
                return p.checked;
            });
        };

        vm.toggleAll = function () {
            var c = vm.isAllChecked();
            _.each(vm.topDomains.data, function (p) {
                p.checked = !c;
            });
            updateCombinedAffinity();
        };

        vm.computeCostEffectiveness = function (domain) {
            if (angular.isUndefined(domain.cpm) || domain.cpm == -1) return '';
            else return domain.cpm * 100 / domain.pseudoAffinity;
        };

        vm.sortBy = function (newPredicate) {
            if (vm.predicate == newPredicate) {
                vm.orderDesc = !vm.orderDesc;
            } else {
                vm.predicate = newPredicate;
                vm.orderDesc = vm.predicate != 'name';
            }
        };

        vm.updateTopDomainsList = function () {
            vm.topDomains = {
                data: [],
                loaded: false
            };
            if (_.isEmpty(vm.targetGroup.criteria)) {
                vm.showEmptyTargetGroupWarning = true;
            } else {
                vm.showEmptyTargetGroupWarning = false;

                // Income range to criterion array
                if (!angular.isUndefined(vm.incomeRange)) {
                  if (vm.targetGroup) {
                    vm.targetGroup.criteria.income = CountriesService.rangeToIncomeCriterion(vm.incomeRange);
                  }
                }
                if (!angular.isUndefined(vm.targetGroup.criteria.children)) vm.targetGroup.criteria.children.sort();
                if (!angular.isUndefined(vm.targetGroup.criteria.householdsize)) vm.targetGroup.criteria.householdsize.sort();

                DomainsService.getDomains({
                    country: [vm.targetGroup.country],
                    gender: angular.isUndefined(vm.targetGroup.criteria.gender) ? vm.targetGroup.criteria.gender : vm.targetGroup.criteria.gender.sort(),
                    age: angular.isUndefined(vm.targetGroup.criteria.age) ? vm.targetGroup.criteria.age : vm.targetGroup.criteria.age.sort(),
                    education: vm.targetGroup.criteria.education,
                    employment: vm.targetGroup.criteria.employment,
                    income: angular.isUndefined(vm.targetGroup.criteria.income) ? vm.targetGroup.criteria.income : [vm.targetGroup.criteria.income[0], vm.targetGroup.criteria.income[vm.targetGroup.criteria.income.length - 1]],
                    children: angular.isUndefined(vm.targetGroup.criteria.children) ? vm.targetGroup.criteria.children : vm.targetGroup.criteria.children.sort(),
                    householdsize: angular.isUndefined(vm.targetGroup.criteria.householdsize) ? vm.targetGroup.criteria.householdsize : [vm.targetGroup.criteria.householdsize[0], vm.targetGroup.criteria.householdsize[vm.targetGroup.criteria.householdsize.length - 1]]
                }).then(function (domains) {
                    //TODO: look out for errors
                    vm.topDomains.data = domains.data;
                    vm.topDomains.loaded = true;
                });
            }
        };

        vm.getSelectedDomainsNames = function () {
            return (_.pluck(vm.selectedDomains, 'name')).toString();
        };

        function updateCombinedAffinity() {
            if (vm.selectedDomains.length > 1) {

                // Income range to criterion array
                if (!angular.isUndefined(vm.incomeRange)) {
                  if (vm.targetGroup) {
                    vm.targetGroup.criteria.income = CountriesService.rangeToIncomeCriterion(vm.incomeRange);
                  }
                }
                if (!angular.isUndefined(vm.targetGroup.criteria.children)) vm.targetGroup.criteria.children.sort();
                if (!angular.isUndefined(vm.targetGroup.criteria.householdsize)) vm.targetGroup.criteria.householdsize.sort();

                DomainsService.getDomains({
                    domain: _.pluck(vm.selectedDomains, 'name'),
                    country: [vm.targetGroup.country],
                    gender: angular.isUndefined(vm.targetGroup.criteria.gender) ? vm.targetGroup.criteria.gender : vm.targetGroup.criteria.gender.sort(),
                    age: angular.isUndefined(vm.targetGroup.criteria.age) ? vm.targetGroup.criteria.age : vm.targetGroup.criteria.age.sort(),
                    education: vm.targetGroup.criteria.education,
                    employment: vm.targetGroup.criteria.employment,
                    income: angular.isUndefined(vm.targetGroup.criteria.income) ? vm.targetGroup.criteria.income : [vm.targetGroup.criteria.income[0], vm.targetGroup.criteria.income[vm.targetGroup.criteria.income.length - 1]],
                    children: angular.isUndefined(vm.targetGroup.criteria.children) ? vm.targetGroup.criteria.children : vm.targetGroup.criteria.children.sort(),
                    householdsize: angular.isUndefined(vm.targetGroup.criteria.householdsize) ? vm.targetGroup.criteria.householdsize : [vm.targetGroup.criteria.householdsize[0], vm.targetGroup.criteria.householdsize[vm.targetGroup.criteria.householdsize.length - 1]]
                }).then(function (response) {
                    //TODO: look out for errors
                    vm.combinedAffinity = response.data.combinedAffinity;
                });
            } else vm.combinedAffinity = vm.selectedDomains[0].pseudoAffinity;
        }

        $scope.$watch(function () {
                return vm.topDomains;
            },
            function (topDomains) {
                vm.selectedDomains = _.filter(topDomains.data, function (domain) {
                    return domain.checked;
                });
                if (vm.selectedDomains.length > 0) updateCombinedAffinity();
            },
            true
        );
    }
})();
